import React from "react";
import shop from "../assets/imgTwo/Illustration.svg";
import "../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const HeroSection = () => {
  return (
    <section
      id="about"
      className=" bg-[#FFFFFF] md:px-[5em] py-16 animate-slidein"
    >
      <div className="container px-2 md:px-0 mx-auto flex flex-col-reverse justify-between md:flex-row items-center">
        <div className="w-full md:w-1/2 p-4">
          <h2 className="text-2xl md:text-[2.5rem] font-bold mb-4 leading-normal">
          Boost E-Commerce with Seamless Payments          </h2>
          <p className="text-gray-800 text-lg">
          Enhance user experience, streamline transactions, and grow your business with secure, flexible payment integrations designed for modern e-commerce, enabling faster checkouts, improved customer satisfaction, and seamless global expansion.          </p>
       
         
        </div>
        <div className="w-full md:w-[35em] p-2 flex md:justify-end">
          <img src={shop} alt="sarepay" className="rounded-lg" />

        </div>
      </div>
    </section>
  );
};

const AboutSection = () => (
  <section
    id="home"
    className=" bg-[#F7F7F7] md:px-[5em] py-16 animate-slidein"
  >
    <div className="container mx-auto">
      <h2 className="text-center md:text-4xl font-bold pt-4">Boost E-Commerce with Uniswitch Checkout,<br></br>
        Collections, and Payouts with Uniswitch</h2>
      <p className="text-center py-8">E-commerce thrives on seamless payments and Uniswitch delivers.</p>
      <div className="grid gap-8 md:grid-cols-2">
  <div className="bg-[#001100] rounded-2xl p-4 py-12 text-white px-[3em] w-full mx-auto">
    <h3 className="font-bold text-xl mb-4">Virtual Accounts</h3>
    <p>Assign unique virtual accounts for easy reconciliation of customer payments.</p>
  </div>

  <div className="bg-[#001100] rounded-2xl p-4 py-12 text-white px-[3em] w-full mx-auto">
    <h3 className="font-bold text-xl mb-4">Instant Disbursements</h3>
    <p>Pay merchants, vendors, and delivery agents in real time.</p>
  </div>

  <div className="bg-[#001100] rounded-2xl p-4 py-12 text-white px-[3em] w-full mx-auto md:col-span-2 md:w-[35em] md:mx-auto">
    <h3 className="font-bold text-xl mb-4">Payment Gateway & Checkout</h3>
    <p>Integrate secure payment gateways for smooth online transactions.</p>
  </div>
</div>

    </div>

  </section>
);

export const Commerce = () => (
  <div className="font-san mx-auto bg-[#FFFFFf] pt-6">
    <Navbar />
    <HeroSection />
    <AboutSection />
    <Footer />
  </div>
);

export default Commerce;
